import LoginInLogica from './loginInLogica';
import ImportTreasureFiles from './ImportTreasureFiles';
import ImportSTAFiles from './ImportSTAFiles';

export default {
  LoginInLogica,
  ImportTreasureFiles,
  ImportSTAFiles,
};
